import request from '@/utils/request' // 引入封装的request.js文件
// 暴露出我们的接口请求,export导出


// 获取资讯列表接口
export function SxAll(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Detail(data) {
  return request({
    url: '/bolan/article/',
    method: 'post',
    data: data,
  })
}

export function ViewList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function CjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZqList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function YpList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZxList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function CkAll(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function GcJcList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function JrJgList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function GjZxList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZxTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZxZqList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZxYpList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZxAllList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZxJcList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZxJrList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZxGjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function FpAll(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function SpGc(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function SjJp(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function MzFp(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function RiskList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function InvestAll(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Dx(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Zx(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Cx(query) {
  return request({
    url: '/bolan/stockpool/',
    method: 'get',
    params: query
  })
}

export function StocksAll(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function XgList(query) {
  return request({
    url: '/bolan/innovation/',
    method: 'get',
    params: query
  })
}

export function RgList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function KcList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function FeatureAll(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function FeatureLcList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function FeatureETFList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function FeatureKzzList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function FeatureGgList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function LatestList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function FundTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function PzList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function PzTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function HqList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function HqTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function XjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function XjTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function JyTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function YxTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Market(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Ag(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function RzRq(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Chance(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Report(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function TimeList(query) {
  return request({
    url: '/bolan/hour/',
    method: 'get',
    params: query
  })
}

export function HeadlinesList(query) {
  return request({
    url: '/bolan/hour/',
    method: 'get',
    params: query
  })
}

export function HotList(query) {
  return request({
    url: '/bolan/hour/',
    method: 'get',
    params: query
  })
}

export function Pk(query) {
  return request({
    url: '/bolan/hour/',
    method: 'get',
    params: query
  })
}

export function Comments(query) {
  return request({
    url: '/bolan/hour/',
    method: 'get',
    params: query
  })
}

export function Combo(query) {
  return request({
    url: '/bolan/article/',
    method: 'post',
    data: query,
  })
}

export function Category(query) {
  return request({
    url: '/bolan/bmenu/',
    method: 'get',
    params: query
  })
}

export function StockPool(query) {
  return request({
    url: '/bolan/stockpool/',
    method: 'post',
    data: query,
  })
}

export function Jy(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function Yx(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function RgTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZtFxList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function FxTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function ZtYcList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function YcTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function JxList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function JxTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function KcTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function TyList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function TyTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function KcYxList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function KcYxTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function SgList(query) {
  return request({
    url: '/bolan/innovation/',
    method: 'get',
    params: query
  })
}

export function SgTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function SsList(query) {
  return request({
    url: '/bolan/innovation/',
    method: 'get',
    params: query
  })
}

export function SsTjList(query) {
  return request({
    url: '/bolan/article/',
    method: 'get',
    params: query
  })
}

export function innovation(query) {
  return request({
    url: '/bolan/innovation/',
    method: 'get',
    params: query
  })
}

export function SearchList(query) {
  return request({
    url: '/bolan/search/',
    method: 'get',
    params: query
  })
}







// WEBPACK FOOTER //
// ./src/api/news.js